import { useTransactions } from 'contexts/Transactions';
import React from 'react';

const IncludeOnePerson = () => {
  const { rewardCustomersIsEnabled } = useTransactions();
  return (
    <div className="vbz-icon-beneficiaries" data-testid="test-include-one-icon">
      <div
        className={
          rewardCustomersIsEnabled ? 'vbz-icon-beneficiaries-include-team2' : 'vbz-icon-beneficiaries-include-one'
        }
      />
    </div>
  );
};

export default IncludeOnePerson;
